export default "__VITE_ASSET__B0Pc4RHv__"